import {takeLatest, takeEvery, select, put, all, call, push} from 'redux-saga/effects';
import pages from '../pages.js';
import {GET_SETTINGS, GET_SETTINGS_SUCCESS, GET_SETTINGS_ERROR,
    POST_SETTINGS, POST_SETTINGS_SUCCESS, POST_SETTINGS_ERROR, 
    NOTIFICATION_TYPE, LOGOUT, POST_SESSIONS_PRIVACY, 
    POST_SESSIONS_PRIVACY_SUCCESS, POST_SESSIONS_PRIVACY_ERROR}
from '../actions/constants';
import { showNotification } from '../actions/index';

const commonHeaders = {'X-Requested-With': 'XMLHttpRequest'};

export function* getSettings(action) {
    const { name } = action;
    try {
        if (pages[name].rest) {
            const response = yield call(fetch, pages[name].rest, {
                credentials: 'same-origin',
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    ...commonHeaders
                },
            });
            if (response.status !== 200) {
                throw response;
            }
            const settings = yield call([response, 'json']);

            if (settings.userConsents || settings.consents.userConsents) {
                let userConsents = settings.userConsents? settings.userConsents: settings.consents.userConsents;
                const CONSENTS_TYPE_PRIORITY_LIST = ['PRIVACY', 'TOS', 'PID', 'DATA_TRANSFER', 'PID_HEALTH', 'AGE', 'MARKETING'];
                var userConsentsSortedByType = [];
                // Hackety hack to sort consents for ui
                for (let i = 0; i < CONSENTS_TYPE_PRIORITY_LIST.length; i++) {
                    var nextUserConsent = userConsents.filter(userConsent => userConsent.type === CONSENTS_TYPE_PRIORITY_LIST[i]);  
                    if (nextUserConsent.length > 0) {
                        userConsentsSortedByType.push(nextUserConsent[0]);
                        userConsents = userConsents.filter(userConsent => userConsent.type !== nextUserConsent[0].type);
                    }      
                }
                // If we fetch consents that aren't in the priority list, let's just add them to the end of the list
                for (let i = 0; i < userConsents.length; i++) {
                    userConsentsSortedByType.push(userConsents[i]);
                }
                userConsents = userConsentsSortedByType;
    
                // Localization keys in database work with Legacy, not with i18next, need to assing the namespace with :
                for (let i = 0; i < userConsents.length; i++) {
                    if (userConsents[i].name.indexOf(':') === -1) {
                        userConsents[i].name = userConsents[i].name.replace('.', ':');
                    }
                    if (userConsents[i].description.indexOf(':') === -1) {
                        userConsents[i].description = userConsents[i].description.replace('.', ':');
                    }
                } 
            }
            
            yield put({
                type: GET_SETTINGS_SUCCESS,
                settings,
                name
            });
        }
    } catch (error) {
        yield put({
            type: GET_SETTINGS_ERROR,
            error
        });
    }
}

export function* postSettings(action) {
    const { name } = action;
    try {
        if (pages[name].rest) {
            const settings = yield select(state => {return state.settings[name];});
            const response = yield call(fetch, pages[name].rest, {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...commonHeaders
                },
                body: JSON.stringify(settings)
            });
            if (response.status !== 200) {
                throw response;
            }
            yield put({
                type: POST_SETTINGS_SUCCESS,
                settings,
                name
            });
            yield put(showNotification(NOTIFICATION_TYPE.SUCCESS, 'save_success', 'Settings saved'));
        }
    } catch (error) {
        yield put({
            type: POST_SETTINGS_ERROR,
            error
        });
    }
}

export function* postAllSessionsPrivacy() {
    let bothSuccess = true;
    try {
        const response = yield call(fetch, '/api/sharing/token/invalidate/contenttype/TRAINING_SESSION', {
            credentials: 'same-origin',
            method: 'DELETE',
            headers: {
                ...commonHeaders
            }
        });
        if (response.status !== 200) {
            throw response;
        }
    } catch (error) {
        bothSuccess = false;
    }
    if (bothSuccess) {
        yield put({
            type: POST_SESSIONS_PRIVACY_SUCCESS
        });
        yield put(showNotification(NOTIFICATION_TYPE.SUCCESS, 'save_success', 'Settings saved'));
    } else {
        yield put({
            type: POST_SESSIONS_PRIVACY_ERROR
        });
    }
}

export function* logout() {
    try {
        yield call(fetch, '/logout', {
            credentials: 'same-origin',
            method: 'GET',
            headers: {
                ...commonHeaders
            }
        });
        window.location.href = '/?x=' + Math.floor(Math.random() * 1000);
    } catch (error) {
        console.log("Could't logout the user: " + error);
    }
}

export default function* () {
    yield all([
        takeEvery(GET_SETTINGS, getSettings),
        takeLatest(POST_SETTINGS, postSettings),
        takeLatest(POST_SESSIONS_PRIVACY, postAllSessionsPrivacy),
        takeLatest(LOGOUT, logout)
    ]);
}



// WEBPACK FOOTER //
// ./src/UserSettings/sagas/index.js